var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DropdownSelect } from '@marketing/components/funnel/FormFields/DropdownSelect';
import { clsx } from 'clsx';
import { useState } from 'react';
import Tooltip from '../../Tooltip';
var defaultValues = [
    { value: 'everyorder', label: 'Every order' },
    { value: 'onetime', label: 'One time' },
];
function Frequency(_a) {
    var _b = _a.disabled, disabled = _b === void 0 ? false : _b, _c = _a.id, id = _c === void 0 ? 'select-frequency' : _c, _d = _a.initialValue, initialValue = _d === void 0 ? defaultValues[0].value : _d, _e = _a.handleFrequencyChange, handleFrequencyChange = _e === void 0 ? function () {
        console.log('handleFrequencyChange not provided');
    } : _e, _f = _a.tooltip, tooltip = _f === void 0 ? '' : _f, _g = _a.values, values = _g === void 0 ? defaultValues : _g;
    var _h = useState(initialValue), currentValue = _h[0], setCurrentValue = _h[1];
    var handleChange = function (value) {
        setCurrentValue(value);
        handleFrequencyChange(value);
    };
    return (_jsxs("div", __assign({ className: "flex-grow self-end" }, { children: [_jsxs("div", __assign({ className: clsx('mb-3xs-m', tooltip && 'flex items-center') }, { children: [_jsx("label", __assign({ className: clsx('text-xs-med-m md:text-xs-med-d', tooltip && 'mr-2'), htmlFor: id }, { children: "Frequency" })), tooltip && _jsx(Tooltip, { children: tooltip })] })), _jsx(DropdownSelect, { disabled: disabled, id: id, onCard: true, options: values, value: currentValue, onChange: handleChange })] })));
}
export default Frequency;
